import { moderation } from './misc'

export default {
  title: 'Reglas',

  titles: {
    actions: 'Acciones',
    conditions: 'Condiciones'
  },

  labels: {
    title: 'Título de la regla',
    type: 'Tipo',
    text: 'Texto',
    sender: 'Remitente',
    routingRule: 'Regla de enrutamiento',
    condition: 'Condición',
    providerGroup: 'Grupo de proveedores',
    percentage: 'Porcentaje',
    search: 'Buscar',
    textToCheck: 'Texto para verificar',
    phone: 'Teléfono para verificar',
    keywords: 'Listas de palabras clave',
    contactList: 'Lista de contactos',
    messagePattern: 'Patrones para moderación',
    fallbacks: 'Alternativas',
    buttons: 'Botones',
    urlShortenerPresetId: 'Preajuste',
    mccmnc: 'MCC MNC',
    recipient: 'Destinatario',
    yulore: 'Yulore',

    group: {
      pattern: 'Patrón del grupo'
    },

    add: {
      condition: 'Agregar condición'
    },

    ...moderation
  },

  tags: {
    text: 'Texto',
    sender: 'Remitente',
    recipient: 'Destinatario',
    code: 'Código de operador',
    group: 'Grupo de operadores',
    mcc: 'MCC',
    mnc: 'MNC',
    mccmnc: 'MCC MNC',
    contactList: 'Lista de contactos',
    messagePattern: 'Patrones para moderación',
    type: 'Tipo',
    moderation: 'Moderación',
    keywords: 'Palabras clave',
    fallbacks: 'Alternativas',
    buttons: 'Botones',
    urlShortenerPresetId: 'Preajuste de enlaces cortos',
    yulore: 'Yulore'
  },

  hints: {
    noRule: 'Condición aún no seleccionada. Haga clic en esta línea para seleccionar.',
    phone: 'Introduzca en este campo un teléfono para comprobar si existe en las listas de contactos seleccionadas.',
    yulore: 'Puede introducir cualquier numero entero.<br>Escriba un numero y presione Enter o quite el foco para agregarlo.<br>Si el numero ya esta en la lista, se eliminara.'
  },

  buttons: {
    add: {
      rule: 'Agregar regla',
      group: 'Agregar grupo',
      condition: 'Agregar condición'
    },
    remove: {
      rule: 'Eliminar regla',
      group: 'Eliminar grupo'
    }
  }
}
